;(function (global, factory) {
  typeof define === 'function' && define.amd ? define('MM/Models/ClientPortal/AccountSettings/RoleLevel',[], factory) :
  typeof exports === 'object' && typeof module !== typeof void 0 ? module.exports = factory() :
  console && console.log('RoleLevel works only in AMD')
}(this/* window */, function () { 
  function RoleLevel(parentRoleId, hasCustomText, hasProductTypeSelection, levelTitle, options) {
    Object.defineProperty(this, 'ParentRoleId', { writable: !0, configurable: !0, enumerable: !0, value: parentRoleId });
    Object.defineProperty(this, 'HasCustomText', { writable: !0, configurable: !0, enumerable: !0, value: !!hasCustomText });
    Object.defineProperty(this, 'HasProductTypeSelection', { writable: !0, configurable: !0, enumerable: !0, value: !!hasProductTypeSelection });
    Object.defineProperty(this, 'LevelTitle', { writable: !0, configurable: !0, enumerable: !0, value: levelTitle });
    Object.defineProperty(this, 'Options', { writable: !0, configurable: !0, enumerable: !0, value: options || [] });
  }

  return RoleLevel;
}));
  
